import { render, staticRenderFns } from "./CmsTabsItems.vue?vue&type=template&id=19dc9aab&scoped=true"
import script from "./CmsTabsItems.vue?vue&type=script&lang=js"
export * from "./CmsTabsItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dc9aab",
  null
  
)

export default component.exports